import Router from 'vue-router'

export default class extends Router {
  currentRouteIndex () {
    return this.options.routes.findIndex(route => route.name === this.currentRoute.name)
  }

  firstRouteIndex () {
    for (const [index, route] of this.options.routes.entries()) {
      console.log('route', route)
      if (!route.hidden) {
        return index
      }
    }

    return this.options.routes.length - 1
  }

  lastRouteIndex () {
    let lastRouteIndex = 0
    for (const [index, route] of this.options.routes.entries()) {
      if (!route.hidden) {
        lastRouteIndex = index
      }
    }

    return lastRouteIndex
  }
}
